.headerWordmark {
  height: 60px;
  user-select: none;
}
